// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import directive from './directive'
import '@/assets/font/iconfont.js'
import Icon from '@/components/icon/Icon'
import filters from '@/filters/index'
import echarts from 'echarts'
import '@/assets/css/tailwind.css' // 添加这行  
import './permission' // permission control
import CommonApi from '@/api/common.js';
Vue.prototype.$echarts = echarts

Vue.component('Icon', Icon)
Vue.use(ElementUI)

for(let key in filters){
	Vue.filter(key,filters[key]);
}
Vue.prototype.$filter = filters;

Vue.config.productionTip = false


Vue.prototype.roundToDecimalPlace = function(number, decimalPlaces){
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
}

Vue.prototype.getPrice = function(price){
  return this.roundToDecimalPlace(price,2)
}

Vue.prototype.randomString = function(e,str){
  e = e || 32;
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
  a = t.length,
  n = "";
  for (var i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n+""+str;
}

Vue.prototype.getAppinfo = function(key){
  var obj = {
    "balance_text":"余额",
    "welfare_text":"积分"
  }
  return obj[key];
}


Vue.prototype.getSetting_common = function(Params,callback){
  CommonApi.getSettings(Params, true)
    .then(data => {
      callback(data.data);
    })
  .catch(error => {});
}
Vue.prototype.preImg = function(Params,callback){
  CommonApi.getSettings(Params, true)
    .then(data => {
      callback(data.data);
    })
  .catch(error => {});
}

//是否需要选择供应商
Vue.prototype.getInas = function(Params,callback){
  CommonApi.getInas(Params, true)
    .then(data => {
      callback(data.data);
    })
  .catch(error => {});
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js